import { AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const logo = require('../../../../assets/img/logo.png');

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  logo: {
    height: 'auto',
    width: '132px',
  },
  topbar: {
    padding: '20px',
    paddingLeft: '48px',
  }
}));

export const Topbar = (props: { className?: string}) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
    >
      <Toolbar className={classes.topbar}>
        <RouterLink to="/">
          <img
            className={classes.logo}
            alt="Logo"
            src={logo}
          />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
